/*
 * JUNGCARDS: precise search for Yu-Gi-Oh! names.
 *
 * Shopify's default search also matches product descriptions (and semantically similar words), so
 * "branded" (the Yu-Gi-Oh! archetype) returned 100+ products that only mention a brand somewhere.
 * Words that form a known name (assets/jc-search-names.js: archetypes) are
 * scoped to title, product type, tags and vendor; all other words stay normal search words:
 *   branded         -> (title:branded OR product_type:branded OR tag:branded OR vendor:branded)
 *   sky striker     -> (title:sky OR ...) (title:striker OR ...)
 *   branded hüllen  -> (title:branded OR ...) hüllen
 *   hüllen schwarz  -> hüllen schwarz                    (no name: unchanged)
 * Partial words still match (Shopify does prefix matching). Queries that already use search syntax
 * (field:, quotes, *, OR/AND/NOT) are left alone.
 *
 * Used by every search form (submit), predictive search (assets/predictive-search.js) and the
 * search page, which shows the plain words again (snippets/jc-search-terms.liquid) and falls back
 * to the normal search when the precise one finds nothing (sections/main-search.liquid).
 */
(function () {
  var names = null;
  var longest = 1;

  function key(word) {
    return word
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  function loadNames() {
    if (names) return names;
    names = {};
    (window.jcSearchNames || []).forEach(function (name) {
      names[name] = true;
      longest = Math.max(longest, name.split(' ').length);
    });
    return names;
  }

  function field(word) {
    return '(title:' + word + ' OR product_type:' + word + ' OR tag:' + word + ' OR vendor:' + word + ')';
  }

  function scope(raw) {
    var q = String(raw || '').trim();
    if (!q || /[:"*()\\]|\b(OR|AND|NOT)\b/.test(q)) return q;
    var words = q
      .split(/[\s\/–—-]+/)
      .map(function (w) {
        return w.replace(/^[-+]+/, '');
      })
      .filter(Boolean);
    if (!words.length || words.length > 12) return q;

    var known = loadNames();
    var keys = words.map(key);
    var scoped = [];
    var any = false;
    /* Every word that is part of a name, also overlapping ones ("dark magician" + "magician girl"). */
    for (var i = 0; i < words.length; i++) {
      for (var len = Math.min(longest, words.length - i); len > 0; len--) {
        var part = keys.slice(i, i + len);
        if (!part.every(Boolean) || !known[part.join(' ')]) continue;
        for (var j = i; j < i + len; j++) scoped[j] = true;
        any = true;
      }
    }
    if (!any) return q;

    return words
      .map(function (w, n) {
        return scoped[n] ? field(w.replace(/[^\p{L}\p{N}]/gu, '')) : w;
      })
      .join(' ');
  }
  window.jcScopeQuery = scope;

  /* Bubble phase: Dawn's own handlers (empty query, selected suggestion) run first and may cancel. */
  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(form.getAttribute('action') || '')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var scoped = scope(input.value);
    if (scoped === input.value.trim()) return;
    event.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', scoped);
    window.location.assign(form.getAttribute('action').split('?')[0] + '?' + params.toString());
  });
})();
